import React from 'react';

const GetInTouchCard = () => {
  return (
    <div className='get-in-touch-card'>
      <p className='title'>Get in touch</p>
      <div className='description'>AdSurge is currently in private beta. Submit your information below to request access. Our team will review your request and be in touch with you shortly.</div>
    </div>
  );
};

export default GetInTouchCard;